import {
  loadUploadedFiles as getFileData,
  validateBulkEmails,
  deleteFileBulkEmails,
  loadEmailsList,
  DownloadReportService,
  reValidateBulkEmails,
  apiCall,
} from "../utility/apiCall";
import Session from "../utility/session";

export const getUploadedFiles = async (payload) => {
  //update this call with common service call
  // console.log("Get Files Data");
  // console.log(JSON.stringify(payload));
  return await getFileData("api/get-filedata", "POST", payload);
};
export const startBulkEmailValidation = async (payload) => {
  return await validateBulkEmails("api/start-validation", "POST", payload);
};

// revalidation
export const startBulkReEmailValidation = async (payload) => {
  return await reValidateBulkEmails("api/re-validate-emails", "POST", payload);
};

export const deleteBulkEmailValidation = async (payload) => {
  // console.log(payload);
  return await deleteFileBulkEmails("api/delete-validation", "POST", payload);
};
export const DownloadValidationReport = async (payload) => {
  // console.log(JSON.stringify(payload));
  return await DownloadReportService("api/download-report", "POST", payload);
};
export const DownloadSingleEmailsReport = async (payload) => {
  // console.log(JSON.stringify(payload));
  return await DownloadReportService(
    "api/download-report/singleEmails",
    "POST",
    payload
  );
};

export const loadEmails = async (payload) => {
  // console.log(JSON.stringify(payload));
  return await loadEmailsList("api/get-emails", "POST", payload);
};


export const getCompanyProfileInfo = async () => {
  return await apiCall(
    "api/company/profile-info",
    "GET",
    {},
    { username: Session.getItem(Session.CURRENT_USER_NAME) }
  );
};

export const postCountry = async (country) => {
  return await apiCall(
    "api/country/update",
    "POST",
    { country }
  )
}


// WEBPACK FOOTER //
// ./src/services/EmailVerifiedFiles.js